function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M27.4902 439H93.6702L146.2 387.8L112.39 354.14L107.25 354.57C73.9302 357.37 44.7602 378.77 33.0202 410.07C29.5396 419.327 27.6693 429.112 27.4902 439V439Z",
  fill: "#22B063"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93 439H264.38C263.28 432.56 262.45 426.22 260.98 420.1C252.3 384.1 221.2 358 184.37 354.54L178.59 354L93 439Z",
  fill: "#2F7920"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M93.1802 272.91C80.3102 247.12 91.8202 216.09 111.54 208.27C134.54 199.14 158.92 216.27 172.86 193.14C178.04 196.54 218.92 222.97 196.61 270.42C173.24 320.14 93.1802 272.91 93.1802 272.91Z",
  fill: "#2F7920"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M189 270H196.25C197.775 270 199.238 270.606 200.316 271.684C201.394 272.762 202 274.225 202 275.75V284.26C202 285.785 201.394 287.248 200.316 288.326C199.238 289.404 197.775 290.01 196.25 290.01H189V270Z",
  fill: "#97C17E"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M101 290H93.75C92.225 290 90.7625 289.394 89.6841 288.316C88.6058 287.238 88 285.775 88 284.25V275.74C88.0026 274.217 88.6096 272.757 89.6877 271.681C90.7657 270.604 92.2267 270 93.75 270H101V290Z",
  fill: "#97C17E"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M187.43 270C152.71 269.47 139.7 256.17 122.78 256.17C105.51 256.17 96.2202 270 96.2202 270L97.0002 299.44C97.2564 306.711 99.1752 313.826 102.609 320.24C106.043 326.654 110.901 332.196 116.81 336.44C125.004 342.305 134.828 345.459 144.905 345.459C154.982 345.459 164.806 342.305 173 336.44L173.07 336.38C178.995 332.146 183.869 326.609 187.316 320.194C190.763 313.779 192.69 306.658 192.95 299.38L194.16 270H187.43Z",
  fill: "#97C17E"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M259.06 145.33C247.171 133.472 240.428 117.411 240.29 100.62C240.29 84.0121 246.887 68.0845 258.631 56.341C270.375 44.5974 286.302 38 302.91 38C319.701 38.1361 335.764 44.8793 347.62 56.77L347.81 57.19L261 145L259.06 145.33Z",
  fill: "#F6C449"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M302.91 163.23C286.504 163.285 270.741 156.851 259.06 145.33L347.62 56.77C356.254 65.5758 362.095 76.7347 364.412 88.8473C366.728 100.96 365.417 113.487 360.641 124.857C355.866 136.227 347.84 145.934 337.57 152.761C327.3 159.587 315.242 163.229 302.91 163.23Z",
  fill: "#E3AF36"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M282.96 92.61L300.84 110.49L327.7 83.62",
  stroke: "white",
  strokeWidth: 10,
  strokeMiterlimit: 10
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.32 113.47L136.55 141.36",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M136.49 113.53L164.38 141.3",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M468.7 112.81L440.93 140.7",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M440.86 112.87L468.76 140.64",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M573.38 439H507.19L454.67 387.8L488.48 354.14L493.62 354.57C526.94 357.37 556.11 378.77 567.85 410.07C571.331 419.327 573.201 429.112 573.38 439V439Z",
  fill: "#22B063"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M507.87 439H336.49C337.59 432.56 338.42 426.22 339.89 420.1C348.57 384.1 379.67 358 416.5 354.54L422.28 354L507.87 439Z",
  fill: "#2F7920"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M454.81 192.49C443.259 192.49 431.968 195.915 422.364 202.333C412.76 208.75 405.275 217.872 400.855 228.544C396.435 239.215 395.279 250.958 397.533 262.287C399.787 273.616 405.35 284.022 413.519 292.189C421.687 300.356 432.094 305.917 443.423 308.169C454.752 310.421 466.495 309.263 477.166 304.842C487.837 300.42 496.957 292.933 503.373 283.328C509.789 273.723 513.212 262.431 513.21 250.88C513.227 243.206 511.728 235.605 508.799 228.513C505.871 221.42 501.569 214.976 496.143 209.55C490.716 204.125 484.272 199.825 477.178 196.897C470.085 193.969 462.484 192.472 454.81 192.49V192.49Z",
  fill: "#2F7920"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500 270H507.25C508.775 270 510.238 270.606 511.316 271.684C512.394 272.762 513 274.225 513 275.75V284.26C513 285.785 512.394 287.248 511.316 288.326C510.238 289.404 508.775 290.01 507.25 290.01H500V270Z",
  fill: "#97C17E"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M411 290H403.75C402.225 290 400.762 289.394 399.684 288.316C398.606 287.238 398 285.775 398 284.25V275.74C398 274.215 398.606 272.752 399.684 271.674C400.762 270.596 402.225 269.99 403.75 269.99H411V290Z",
  fill: "#97C17E"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M490.28 249.4C454.28 273.4 420.77 249.11 420.77 249.11L406.26 270L407.26 300.4C407.514 307.671 409.433 314.787 412.867 321.201C416.301 327.615 421.16 333.157 427.07 337.4C435.255 343.277 445.075 346.443 455.152 346.452C465.228 346.461 475.054 343.313 483.25 337.45L483.33 337.39C489.254 333.156 494.128 327.618 497.575 321.203C501.021 314.788 502.949 307.668 503.21 300.39L504.4 270L490.28 249.4Z",
  fill: "#97C17E"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M396.67 413.15C386.729 400.345 373.95 390.024 359.34 383H242.34C227.016 390.453 213.737 401.523 203.647 415.255C193.558 428.988 186.963 444.969 184.43 461.82V462H417.61C414.943 444.188 407.731 427.364 396.67 413.15V413.15Z",
  fill: "#E3AF36"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 201.36L290 202V360L289 361C256 359.45 233.23 348.26 217.5 336.47C235.01 317.47 229.5 293.47 227.55 279.75C225.95 269.4 226.856 258.818 230.19 248.89C234.583 236.27 242.418 225.131 252.811 216.731C263.204 208.332 275.739 203.007 289 201.36V201.36Z",
  fill: "#22B063"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M386.77 336.71C369.26 349.84 343.06 361.51 303.64 361.51H300.64C296.64 361.51 292.75 361.43 289.01 361.24V201.55C291.949 201.184 294.908 201 297.87 201H306.42C321.299 200.999 335.809 205.632 347.934 214.255C360.06 222.879 369.198 235.065 374.08 249.12C377.417 259.054 378.319 269.645 376.71 280C374.73 293.72 369.26 317.74 386.77 336.71Z",
  fill: "#2F7920"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.87 307H259V287H254C253.03 287 252.072 287.209 251.189 287.612C250.307 288.015 249.521 288.603 248.886 289.336C248.251 290.069 247.78 290.93 247.507 291.861C247.233 292.791 247.163 293.77 247.3 294.73L248.22 301.19C248.45 302.794 249.247 304.262 250.468 305.328C251.688 306.395 253.25 306.988 254.87 307V307Z",
  fill: "#97C17E"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M289 240C252.47 257.51 253.34 286.9 253.34 286.9H253.12C252.997 290.774 253.164 294.651 253.62 298.5L255.86 317.3C257.2 332.15 266.62 348.79 278.7 357.45C287.6 363.84 295.14 366.56 302.44 366.56C309.74 366.56 317.28 363.84 326.18 357.45C338.26 348.79 347.68 332.15 349.02 317.3C349.02 317.3 351.36 297.58 351.41 297.11C324.33 292.73 294.79 270.64 289 240Z",
  fill: "#97C17E"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M243.45 383L275.21 413.24L303.9 383H243.45Z",
  fill: "#F6C449"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M298.9 383L330.66 413.24L359.35 383H298.9Z",
  fill: "#F6C449"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

export default __webpack_public_path__ + "static/media/participation_alert.26cf297e.svg";
export { SvgComponent as ReactComponent };